import { ApiResponse, getFromServer, postToServer } from "server";
import { user } from "server/AccrossTypes";
import {
  GetUserAggregationBySchoolRoleOutput,
  GetUserByIdOutput,
  GetUserByRoleAndUsernameOutput,
  UpdateUserProfileOutput,
  UsersInSchoolOutput,
} from "../OutputsTypes";
import { GetUserByRoleAndUsernameInput } from "../InputsTypes";

//  Route : GET /users/all
export const getAllUsers = async (): Promise<ApiResponse<user[]>> => {
  return await getFromServer<user[]>("/users/all");
};

// Fichier du request : // Route : GET /users/all/in-school
export const getUsersInSchool = async (): Promise<
  ApiResponse<UsersInSchoolOutput>
> => {
  return await getFromServer<UsersInSchoolOutput>("/users/all/in-school");
};

// Route : GET /users/agg/school/agg/role
export const getUserAggregationBySchoolRole = async (): Promise<
  ApiResponse<GetUserAggregationBySchoolRoleOutput[]>
> => {
  return await getFromServer<GetUserAggregationBySchoolRoleOutput[]>(
    "/users/agg/school/agg/role",
  );
};

// Route : GET /users/find/in-school?userRole=student&username=king
export const getUserByRoleAndUsername = async (
  getUserByRoleAndUsernameInput: GetUserByRoleAndUsernameInput,
): Promise<ApiResponse<GetUserByRoleAndUsernameOutput>> => {
  const url = `/users/find/in-school?userRole=${getUserByRoleAndUsernameInput.userRole}&username=${getUserByRoleAndUsernameInput.username}`;
  return await getFromServer<GetUserByRoleAndUsernameOutput>(url);
};

// Route : POST /users/profile/update
export const updateUserProfile = async (
  file: File,
): Promise<ApiResponse<UpdateUserProfileOutput>> => {
  const url = "/users/profile/update";
  const formData = new FormData();
  formData.append("file", file);

  return await postToServer<FormData, UpdateUserProfileOutput>(url, formData);
};

// Route : GET /users/:id
export const getUserById = async (
  id: string,
): Promise<ApiResponse<GetUserByIdOutput>> => {
  const url = `/users/${id}`;

  return await getFromServer<GetUserByIdOutput>(url);
};
